var YCF_Plugin = window.YCF_Plugin,
  getUrlParams = window.getUrlParams;
import { toQueryString } from '@ykz/ykz-util/base';
export default {
  name: 'appNav',
  data: function data() {
    return {
      weChatId: getUrlParams('weChatId') || window.weChatId || 1,
      simData: getUrlParams('simData') || null,
      promotion: getUrlParams('promotion') || null,
      inMyShop: false,
      inOrderList: false
    };
  },
  filters: {},
  mounted: function mounted() {},
  methods: {
    //进入推广产品页
    toPromoteProduct: function toPromoteProduct() {
      var that = this;
      that.anchorPoint(1, function () {
        var param = {
          weChatId: that.weChatId,
          promotion: that.promotion,
          isShop: 1,
          simData: that.simData || null,
          time: new Date().getTime()
        };
        if (!that.inMyShop) {
          window.location.href = '/front/promoter/myShop?' + toQueryString(param);
        }
      });
    },
    toOrderList: function toOrderList() {
      var that = this;
      that.anchorPoint(2, function () {
        var param = {
          weChatId: that.weChatId,
          promotion: that.promotion,
          type: 0,
          isShop: 1,
          simData: that.simData || null,
          time: new Date().getTime()
        };
        if (!that.inOrderList) {
          window.location.href = '/front/userCenter/orderlist?share=1' + toQueryString(param);
        }
      });
    },
    setNavItemActive: function setNavItemActive() {
      var that = this;
      var urlPathname = location.pathname.toLowerCase();
      if (urlPathname == '/front/promoter/myshop') {
        that.inMyShop = true;
      }
      if (urlPathname == '/front/usercenter/orderlist') {
        that.inOrderList = true;
      }
    },
    //点击按钮触发大数据锚点
    anchorPoint: function anchorPoint(target, callback) {
      var pageName = '';
      var tag = ~~target;
      switch (tag) {
        case 1:
          pageName = 'promoteMall';
          break;
        case 2:
          pageName = 'order';
          break;
      }
      // 大数据锚点(点击产品列表)
      YCF_Plugin.reportUserAnchors({
        event_id: '500186',
        event_content: {
          page_name: pageName,
          tag: tag,
          mall_type: 1
        }
      }).always(function () {
        callback && callback();
      });
    }
  },
  created: function created() {
    this.setNavItemActive();
  }
};